(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["subscription-highlight"] && !Shopify.designMode) return;
  try {
    class SubscriptionHighlight extends HTMLElement {
  connectedCallback() {
    this.attachWidget();
  }

  attachWidget(attempt = 0) {
    const widget = document.querySelector('.paywhirl-plan-selector');
    if (!widget) {
      if (attempt < 40) setTimeout(() => this.attachWidget(attempt + 1), 250);
      return;
    }
    this.widget = widget;
    this.sync();
    this.enforceAllowedPlan();
    this.widget.addEventListener('change', (event) => {
      if (event.target && event.target.name === 'paywhirl-plan-selector-group') this.sync();
    });
    new MutationObserver(() => {
      this.sync();
      this.enforceAllowedPlan();
    }).observe(this.widget, {
      attributes: true,
      subtree: true,
      attributeFilter: ['checked', 'class'],
    });
  }

  enforceAllowedPlan() {
    const hiddenPlanIds = ['2159804477', '2159935549', '2159968317'];
    const fallbackPlanId = '2159837245';
    const checked = this.widget.querySelector('input[name^="selling_plan_"]:checked');
    if (!checked || !hiddenPlanIds.includes(checked.value)) return;
    const fallbackInput = this.widget.querySelector(
      `label[data-plan-id="${fallbackPlanId}"] input`
    );
    if (!fallbackInput || fallbackInput.checked) return;
    fallbackInput.checked = true;
    fallbackInput.dispatchEvent(new Event('change', {bubbles: true}));
  }

  sync() {
    const checked = this.widget.querySelector('input[name="paywhirl-plan-selector-group"]:checked');
    const isSubscribe = !!(checked && checked.value !== '');
    this.setAttribute('data-active', isSubscribe ? 'subscribe' : 'one-time');
    this.syncButtonPrice(isSubscribe);
  }

  syncButtonPrice(isSubscribe) {
    const priceEl = document.querySelector('.product-buy-buttons--cta-price');
    if (!priceEl) return;
    const priceSource = isSubscribe
      ? this.widget.querySelector(
          '.paywhirl-plan-selector-group:not(#paywhirl-one-time-purchase-group) .paywhirl-plan-selector-group-price .paywhirl-price'
        )
      : this.widget.querySelector(
          '#paywhirl-one-time-purchase-group .paywhirl-plan-selector-price .paywhirl-price'
        );
    priceEl.textContent = priceSource ? `· ${priceSource.textContent.trim()}` : '';
  }
}

customElements.get('subscription-highlight') || customElements.define('subscription-highlight', SubscriptionHighlight);
  } catch(e) { console.error(e); }
})();

})();
